<template>
    <div id="mArticle">
        <div class="group_util">
            <rank-option-category @reset-rank-num="resetLoadedRankNum" v-if="tab === 'fandom'"></rank-option-category>
            <rank-option-time @reset-rank-num="resetLoadedRankNum" :date="date"></rank-option-time>
            <star-join-wrap></star-join-wrap>
        </div>

        <div class="fancafe_ranklist" id="fandomeTop10List">
            <rank-item-wrap :itemList="rankList_top3" top3></rank-item-wrap>
            <rank-item-wrap :itemList="rankList_3to9"></rank-item-wrap>
        </div>
        
        <star-article-wrap v-if="tab === 'fandom'"></star-article-wrap>
        <recommend-wrap v-else-if="tab === 'cafe'"></recommend-wrap>
        
        <div class="fancafe_ranklist" id="fandomeRankListView">
            <rank-item-wrap :itemList="rankList_rest"></rank-item-wrap>
        </div>

        <a href="https://cafe.daum.net/supporters/Mhj5/22" target="_blank" class="link_fancafebnr fandom"><img src="//t1.daumcdn.net/cafe_image/fancafe/banner/PC_img_top_fandomrank_banner.png" alt="Daum 공식팬카페가 되려면? 선정 기준과 지원혜택 을 알려드려요! GO"></a>
        <a href="https://cafe.daum.net/supporters/Mhj5/13" target="_blank" class="link_fancafebnr cafe"><img src="//t1.daumcdn.net/cafe_image/fancafe/banner/PC_img_top_fancafe_banner.png" alt="Daum 공식팬카페가 되려면? 선정 기준과 지원혜택 을 알려드려요! GO"></a>
        <a href="https://cafe.daum.net/supporters/Mhj5/44" target="_blank" class="link_fancafebnr cheer"><img src="//t1.daumcdn.net/cafe_image/fancafe/banner/PC_img_top_support_banner.png" alt="Daum 공식팬카페가 되려면? 선정 기준과 지원혜택 을 알려드려요! GO"></a>
            
        <div class="fancafe_ranklist" id="fandomeMoreRankListView">
            <rank-item-wrap :itemList="rankList_more"></rank-item-wrap>
        </div>
        <button class="btn_morelist" id="btn_morelist" v-show="loadedRankNum < rankList.length" @click="loadMoreRanks">
            <span class="ico_bestcafe ico_viewmore">더 보기</span>
        </button>
    </div>
</template>

<script>
import $ from 'jquery';

import { mapState } from 'vuex';

import RankOptionCategory from './RankOptionCategory.vue';
import RankOptionTime from './RankOptionTime.vue';
import StarJoinWrap from './StarJoinWrap.vue';

import StarArticleWrap from "./StarArticleWrap.vue";
import RecommendWrap from "./RecommendWrap.vue"; 
    
import RankItemWrap from "./RankItemWrap.vue";

export default {
    components: {
        RankOptionCategory,
        RankOptionTime,
        StarJoinWrap,
        
        StarArticleWrap,
        RecommendWrap,

        RankItemWrap
    },
    data() {
        return {
            date: 0,
            rankList: [],
            firstLoadedRankNum: 35, // 더보기를 안눌렀을 때 기본으로 표시할 랭킹 아이템 개수
            loadedRankNum: 35, // 화면에 표시된 랭킹 아이템 개수
            loadRankCount: 50, // 더보기 버튼을 클릭했을 때 추가로 표시할 랭킹 아이템 개수
        }
    },
    computed: {
        ...mapState(["tab", "category", "time", "openedLayer", "magCount"]),
        rankList_top3() {
            return this.rankList.slice(0, 3);
        },
        rankList_3to9() {
            return this.rankList.slice(3, 9);
        },
        rankList_rest() {
            return this.rankList.slice(9, this.firstLoadedRankNum);
        },
        rankList_more() {
            return this.rankList.slice(this.firstLoadedRankNum, this.loadedRankNum);
        }
    },
    methods: {
        getRankData() {
            const url = `/_c21_/api/fancafe/ranking/${this.tab}/${this.time}`;
            $.ajax({
                url,
                data: {
                    categoryName: this.category,
                    count: this.magCount
                }
            }).then(function(res) {
                this.date = res.date;
                this.rankList = res[this.tab + "RankViewList"];
                
                this.loadedRankNum = 35;
                if(this.loadedRankNum > this.rankList.length) this.loadedRankNum = this.rankList.length;
            }.bind(this)).catch(error => {
                console.err(error);
            });
        },
        loadMoreRanks() {
            this.loadedRankNum += this.loadRankCount;
        },
        resetLoadedRankNum() {
            this.loadedRankNum = 35;
        }
    },
    watch: {
        "tab": "getRankData",
        "category": "getRankData",
        "time": "getRankData"
    },
    created() {
        this.getRankData();
    }
}
</script>
